// extracted by mini-css-extract-plugin
export default {"cta":"GF-z","disabled":"HF-z"};